enum AutomatedScoringType {
    NO_AUTOMATION = "noAutomation",
    AI_SCORING = "aiScoring",
    EVALUATION_ASSISTANCE = "evaluationAssistance",
}

export default AutomatedScoringType;
